<template>
  <div class="card is-w-60v">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered">
        <div class="mgb-50px">
          <h1 class="title is-size-3 has-text-centered">
            {{ $t('importDonne.title') }}
          </h1>
        </div>
        <uploader v-if="file === null"
                  ref="upload" class="mgt-30px pd-20pxupload-box"
                  @added="fileAdded" @removed="file = null"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :extensions="/\.(xlsx)$/i"
                  @filePrevented="filePrevented"
                  :size="taillePjLimite">
          <div class="columns">
            <div class="column">
              <b-icon
                icon="file-multiple"
                size="is-large"
                type="is-primary">
              </b-icon>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12 is-paddingless is-size-6 has-text-weight-bold">
              <h1 class=" is-size-4 has-text-weight-bold">
                {{ $t('importExcel.dragDrop.title') }}
              </h1>
            </div>
          </div>
          <div class="columns">
            <div class="column is-12 is-paddingless  is-size-6">
              {{ $t('importExcel.dragDrop.formatAndMaxSize') }}
            </div>
          </div>
        </uploader>
        <div class="mgt-30px pd-20px is-full-width min-height-81px" v-else>
          <img src="/static/icons/svg/xlsx.svg" class="is-pulled-left image is-64x64" />
          <div class="is-pulled-left mgl-10px mgt-10px">
            <p class="has-text-grey-light has-text-weight-semibold">
              {{file.name}}
            </p>
            <p class="is-size-7">
              {{file.size | formatSize}} -
              {{file.file.lastModified | formatDate}}
            </p>
          </div>
          <a class="is-pulled-right mg-10px" @click="fileAdded(null)">
              <b-icon
                icon="delete-forever"
                type="is-danger">
              </b-icon>
            </a>
        </div>
        <footer class="mgt-20px">
          <div class="has-text-centered">
            <button
              class="button btn-modal-annuler is-cancel has-text-centered button-modal"
              @click="$parent.close()">
              {{ $t('importExcel.actions.cancel') }}
            </button>
            <button class="button is-addOrEdit has-text-centered button-modal"
                    @click="ajouter" :disabled="!file">
              {{ $t('importExcel.actions.add') }}
            </button>
          </div>
        </footer>
      </section>
    </div>
  </div>
</template>

<script>
import Uploader from '@/components/general/uploader';
import { TAILLE_PJ_LIMITE } from '@/configuration/piecesJointes';
import messageErreur from '@/services/general/messageErreur';
import readFileXlsx from '@/services/general/readFileXlsx';

export default {
  name: 'p_importDonne',
  components: {
    Uploader,
  },
  props: {
    allSheet: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      file: null,
      errorFiles: [],
      taillePjLimite: TAILLE_PJ_LIMITE,
    };
  },
  methods: {
    async ajouter() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const lignesXlsx = await readFileXlsx(this.file, this.allSheet);
        if (this.allSheet) {
          if (!Array.isArray(lignesXlsx)) return;
          lignesXlsx.forEach(sheet => {
            if (!Array.isArray(sheet)) return;
            sheet.forEach((ligne, i) => {
              this.formateLigne(ligne);
              ligne.numLigne = i + 1;
            });
          });
        } else {
          if (!Array.isArray(lignesXlsx)) return;
          lignesXlsx.forEach((ligne, i) => {
            this.formateLigne(ligne);
            ligne.numLigne = i + 1;
          });
        }
        this.$emit('lignesXlsx', lignesXlsx);
        this.$parent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    formateLigne(ligne) {
      Object.keys(ligne).forEach(key => {
        ligne[key] = String(ligne[key]).trim();
      });
    },
    fileAdded(file) {
      this.file = file;
    },
    filePrevented(error) {
      error.file.errorMessage = error.message;
      this.errorFiles.push(error.file);
    },
  },
};
</script>

<style scoped>

</style>
